// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kui-link {
  text-decoration: none;
}
.kui-link:hover {
  text-decoration: underline;
}
.kui-link.disabled {
  cursor: not-allowed;
}

a[class^=awsui_undo-button_] {
  color: #c41dff !important;
  font-weight: 400 !important;
}

a[class^=awsui_undo-button_]:hover {
  text-decoration-color: initial !important;
}

.monitoringCopyLink {
  color: #c41dff;
}

.monitoringCopyLink:hover {
  cursor: pointer;
  text-decoration: underline;
}

.nav-link-custom-button-class {
  display: flex;
  margin-top: -6px;
}

.kivera-external-link a[class^=awsui_link] {
  color: #cf4dff !important;
}

.kivera-external-link-xs a {
  color: #c41dff !important;
  cursor: pointer !important;
  font-size: 12px !important;
  text-decoration: none !important;
}

.kivera-external-link-xs a svg {
  width: 12px !important;
}

.kivera-external-link-xs a:hover {
  text-decoration: underline !important;
}

.kui-button {
  all: unset;
  border-radius: 4px;
  box-shadow: #A6AEAD 0 2px 4px;
  min-width: 112px;
}
.kui-button:not([disabled]):focus {
  box-shadow: #FFFFFF 0 0 0 1px, #C41DFF 0 0 0 2px;
}
.kui-button:focus:not(:focus-visible) {
  box-shadow: none;
}
.kui-button:not([disabled]):not(.kui-button-type-ghost):hover {
  text-decoration: underline;
  text-decoration-color: #FFFFFF;
}
.kui-button-type-ghost:hover {
  text-decoration: underline;
  text-decoration-color: #000000;
}
.kui-button:active {
  -webkit-transform: translateY(1px);
  transform: translateY(1px);
}
.kui-button-fullwidth {
  width: 100%;
}
.kui-button-inner {
  display: flex;
  justify-content: center;
  border-radius: 4px;
}
.kui-button-inner-primary {
  background-color: #C41DFF;
}
.kui-button-inner-secondary {
  background-color: #000000;
}
.kui-button-inner-tertiary {
  background-color: #FF8D1D;
}
.kui-button-inner-ghost {
  border: 1px solid #000000;
}
.kui-button-inner-delete {
  background-color: #FF471A;
}
.kui-button-inner-link {
  background-color: transparent;
}
.kui-button-inner-disabled {
  cursor: not-allowed;
  background-color: #A6AEAD;
}
.kui-button-inner-icon {
  fill: #FFFFFF;
  padding-right: 8px;
}
.kui-button-inner-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #FFFFFF;
}
.kui-button-inner-text-ghost {
  color: #000000;
}
.kui-button-inner-text-ghost:hover {
  text-decoration: underline;
  text-decoration-color: #000000;
}
.kui-button-inner-text:hover {
  box-shadow: none;
}
.kui-button-inner-text-disabled {
  color: #4D5453;
}
.kui-button-inner-large {
  padding: 12px;
}
.kui-button-inner-large-text {
  font-size: 16px;
  line-height: 16px;
}
.kui-button-inner-medium {
  padding: 12px;
}
.kui-button-inner-medium-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.kui-button-inner-medium-text {
  font-size: 16px;
  line-height: 16px;
}
.kui-button-inner-small {
  padding: 8px;
}
.kui-button-inner-small-text {
  font-size: 12px;
  line-height: 12px;
}
.kui-button-inner-extra-small {
  padding: 12px;
}
.kui-button-inner-extra-small-text {
  font-size: 10px;
  line-height: 10px;
}

.kui-button-empty {
  all: unset;
  min-width: 112px;
}
.kui-button-empty-fullwidth {
  width: 100%;
}
.kui-button-empty:active {
  -webkit-transform: translateY(1px);
  transform: translateY(1px);
}
.kui-button-empty-inner {
  display: flex;
  justify-content: center;
  border-radius: 2px;
}
.kui-button-empty-inner-text {
  color: #C41DFF;
  text-decoration: underline;
}
.kui-button-empty-inner-large {
  padding: 18px;
}
.kui-button-empty-inner-large-text {
  font-size: 16px;
  line-height: 16px;
}
.kui-button-empty-inner-medium {
  padding: 12px;
}
.kui-button-empty-inner-medium-text {
  font-size: 14px;
  line-height: 14px;
}

.kui-button-link {
  all: unset;
  min-width: 30px;
}
.kui-button-link:active {
  -webkit-transform: translateY(1px);
  transform: translateY(1px);
}
.kui-button-link-inner {
  display: flex;
  justify-content: center;
  border-radius: 2px;
}
.kui-button-link-inner-text {
  color: #C41DFF;
  text-decoration: underline;
}
.kui-button-link-inner-large {
  padding: 18px 0;
}
.kui-button-link-inner-large-text {
  font-size: 18px;
  line-height: 18px;
}
.kui-button-link-inner-medium {
  padding: 12px 0;
}
.kui-button-link-inner-medium-text {
  font-size: 16px;
  line-height: 16px;
}

.kuiIcon--medium {
  width: 16px;
  height: 16px;
}

.kuiIcon-isLoaded {
  -webkit-animation: kuiIconLoading 250ms ease-in 0s 1 forwards;
  animation: kuiIconLoading 250ms ease-in 0s 1 forwards;
}

.kuiIcon {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
  fill: currentColor;
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
}

.kui-alignMiddle {
  vertical-align: middle !important;
}

.status-badge-container {
  display: flex;
  align-items: center;
}
.status-badge-container > .text {
  margin-right: 6px;
}
.status-badge-container > .icon {
  height: 17px;
}

.sidebar-layout {
  height: 100vh;
}

.app-layout-with-top-nav-children {
  padding-top: 5px;
  background-color: #efefef;
}

.metabase-background main {
  background-color: #efefef !important;
}

/* Custom CSS */
.hover-border-color {
  border-color: #c41dff;
}

.hover-box-shadow {
  box-shadow: 0 0 40px rgba(196, 29, 255, 0.5);
}

.sidebar-topnav {
  display: block !important;
}

.sidebar-aside {
  display: none !important;
}

@media (min-width: 1024px) and (min-height: 690px) {
  .sidebar-topnav {
    display: none !important;
  }
  .sidebar-aside {
    display: flex !important;
  }
}
:root {
  --drop-height: 137px;
  --bouncy-logo-size: 90px;
  --bouncy-shadow-size: 90px;
  --offset: -33px;
  --shadow-height: 8px;
  --bounce-duration: 0.9s;
}

.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
  background-color: rgba(255, 255, 255, 0.8); /*dim the background*/
}

.page-loader-container {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #fff;
}

.bouncy-component {
  margin-left: -45px;
  margin-top: -200px;
}

.bouncy-container {
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: relative;
}

.bouncy-logo {
  width: var(--bouncy-logo-size);
  height: var(--bouncy-logo-size);
  /* position: absolute; */
  top: var(--offset);
  left: calc(50% - var(--bouncy-logo-size) / 2);
  animation-name: bounce;
  animation-duration: var(--bounce-duration);
  animation-direction: alternate;
  animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);
  animation-iteration-count: infinite;
}

.bouncy-shadow {
  width: var(--bouncy-shadow-size);
  height: var(--shadow-height);
  background: radial-gradient(50% 50%, rgb(150, 150, 150), rgba(150, 150, 150, 0.05));
  position: absolute;
  top: calc(var(--offset) + var(--drop-height) + var(--bouncy-shadow-size) - 1.5 * var(--shadow-height));
  left: calc(50% - var(--bouncy-shadow-size) / 2);
  animation-name: grow;
  animation-duration: var(--bounce-duration);
  animation-direction: alternate;
  animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);
  animation-iteration-count: infinite;
}

.org-name-banner {
  display: flex;
  color: rgb(125, 137, 152);
  font-weight: bold !important;
  align-items: center;
}

.org-name-banner svg {
  fill: rgb(125, 137, 152);
}

.org-name-icon {
  padding-right: 7px;
}

.org-name-banner-welcome {
  justify-content: flex-end;
  font-size: 16px !important;
  color: rgb(209, 213, 219) !important;
  width: 100%;
  padding-top: 2px;
}

.org-name-banner-welcome svg {
  fill: rgb(209, 213, 219) !important;
}

.org-name-banner-dashboard {
  padding: 11px 30px;
}

.org-name-banner-app {
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 1000000;
}

.layout-custom-class .layout-custom-header-class {
  padding-top: 8px !important;
}

.layout-form-custom-class .layout-form-custom-header-class {
  padding-top: 6px !important;
}

div[data-page=monitoring] div[class*=awsui_header-controls], div[data-page=simulator] div[class*=awsui_header-controls] {
  padding-top: 10px !important;
}

div[data-page=simulator] th:first-child > div[class*=awsui_header-cell], div[data-page=simulator] td:first-child {
  padding-left: 15px !important;
}

@media screen and (max-width: 688px) {
  .org-name-banner {
    padding: 10px 4px 0px 0px;
  }
  div[class*=awsui_breadcrumbs_]:has(div.custom-breadcrumb-class) {
    margin-top: 0px;
  }
}
@keyframes bounce {
  from {
    transform: translateY(0) scale(1);
  }
  to {
    transform: translateY(var(--drop-height)) scale(1, 0.7);
  }
}
@keyframes grow {
  from {
    transform: scale(0.2, 0.5);
  }
  to {
    transform: scale(1, 0.8);
  }
}
.customBadge {
  background-color: #414d5c;
  color: white;
  border-radius: 5px;
  padding: 0px 5px;
}

.gridFormField {
  margin-top: 25px;
}

@media screen and (max-width: 792px) {
  .gridFormField {
    margin-top: 0px;
  }
}
.list-property-filter {
  display: flex;
}

.list-property-filter > div[class^=awsui_root] > div[class^=awsui_search-field] {
  min-width: 380px !important;
}

span[class^=awsui_filtering-match-highlight] {
  color: #CF4DFF !important;
  background-color: #E3E5E7 !important;
  font-weight: normal !important;
}

.hero-gradient-wrap {
  width: 100%;
  height: 320px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  display: flex;
  position: relative;
}

.hero-gradient-wrap.about {
  height: auto;
}

.image-hero-wrap {
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.hero-gradient-rectangle {
  width: 96%;
  height: 100vh;
  background-image: linear-gradient(rgba(14, 0, 25, 0.58) 43%, #643dad);
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

@media screen and (min-width: 1440px) {
  .image-hero {
    width: 100%;
    height: auto;
  }
  .hero-gradient-wrap {
    margin-top: 4vw;
  }
  .hero-gradient-wrap.about {
    margin-top: 40px;
  }
  .image-hero-wrap {
    transform: translateY(16%);
  }
}
@media screen and (min-width: 1440px) and (max-height: 960px) {
  .image-hero-wrap {
    transform: none;
  }
}
@media screen and (min-width: 1920px) {
  .image-hero {
    max-height: 1000px;
  }
  .hero-gradient-wrap {
    margin-top: 6vw;
  }
}
@media screen and (max-width: 991px) {
  .image-hero {
    width: 1200px;
  }
  .hero-gradient-wrap {
    margin-top: -40px;
  }
  .hero-gradient-wrap.about {
    margin-top: 40px;
  }
}
@media screen and (max-width: 767px) {
  .image-hero {
    width: 800px;
  }
  .hero-gradient-wrap {
    height: 270px;
  }
}
@media screen and (max-width: 479px) {
  .image-hero {
    width: 630px;
  }
  .hero-gradient-wrap {
    height: 220px;
  }
  .image-hero-wrap {
    left: 0%;
    right: 0%;
  }
}
#rules-library-container > div > div > div > div > div[class^=awsui_header] {
  padding-bottom: 0 !important;
  padding-top: 17px !important;
}

#rules-library-container > div > div > div > div > div[class^=awsui_header],
#rules-library-container > div > div > div > div > div[class^=awsui_content],
#rules-library-container > div > div > div > div > div[class^=awsui_footer] {
  background-color: #efefef !important;
}

@media screen and (min-width: 769px) {
  #rules-library-container div[class^=awsui_dialog]:first-child {
    padding-left: 75px;
  }
}
#rules-library-container div[class^=awsui_header] div[class^=awsui_actions] {
  align-items: center !important;
}

.rules-library-header div[class^=awsui_title] {
  display: inline-flex;
  align-items: center;
}

.rules-library-header div[class^=awsui_title] h1[class^=awsui_heading] {
  margin-right: 16px !important;
}

.vertical-separator {
  border-left: black;
  height: 18px;
  margin-top: 6px;
  width: 6px;
  display: block;
}

#rules-library-container > div[class^=awsui_root_] > div[class^=awsui_focus] > div[class^=awsui_dialog] > div[class^=awsui_container_] > div[class^=awsui_content_] {
  padding: 0 !important;
}

.rules-library-provider-segment-filter div[class^=awsui_segment-part_]:not(#\\9 ) {
  display: unset !important;
}

.imported-from-status {
  margin-left: 10px;
  padding-top: 2px;
}

.rules-library-header {
  margin-left: 20px;
  margin-bottom: -5px;
}

@media screen and (max-width: 968px) {
  .vertical-separator {
    display: none;
  }
}
.rules-library-info-badge {
  background-color: #FF8D1C;
  color: #fff;
}

#rules-view-header div[class^=awsui_title] h1[class^=awsui_heading] {
  margin-right: 16px !important;
}

#rules-view-header div[class^=awsui_title] {
  display: inline-flex !important;
  align-items: center !important;
}

#rules-view-header div[class^=awsui_title] span[class^=awsui_info] {
  margin-top: -3px !important;
}

.rules-library-list-items div[class^=awsui_sticky-scrollbar] {
  display: none !important;
}

.rules-library-provider-segment-filter button[class*=awsui_selected_] {
  background-color: #cf4aff !important;
  color: #FFFFFF !important;
}

.rules-library-provider-segment-filter button[class^=awsui_segment_]:hover {
  color: #FFFFFF !important;
}

.rules-library-custom-external-link a {
  color: #c41dff !important;
  cursor: pointer !important;
  text-decoration: none !important;
  font-size: 12px !important;
}

.rules-library-custom-external-link a svg {
  width: 12px !important;
}

.container-header-wrapper.top {
  padding-top: 8px !important;
}

.table-header-padding {
  padding-left: 10px;
}

[data-name=splitpanel-table] table th:nth-child(1), [data-name=splitpanel-table] table td:nth-child(1) {
  display: none;
}

[data-name=splitpanel-table] table tr[class*=awsui_row-selected] td:nth-child(2) {
  border-left: 2px solid #cf4dff !important;
}

.select-dropdown span[class^=awsui_placeholder_] {
  overflow: inherit !important;
}

.multi-select-container ul li {
  width: 100% !important;
}

ul[id^=option-list] li[aria-disabled=true] {
  background-color: #FFF7F7 !important;
  border: 2px solid #D91515 !important;
}

div[class^=awsui_token_]:has(.invalid-option) {
  border: 2px solid #D91515 !important;
  background: #FFF7F7 !important;
}
div[class^=awsui_token_]:has(.invalid-option) span[class^=awsui_description_] {
  color: #D91515 !important;
}

span[class^=awsui_icon_]:has(.invalid-option) {
  display: none !important;
}

.attribute-editor-container div[class^=awsui_controls_] {
  padding-top: 0 !important;
}

.attribute-editor-container div[class^=awsui_button-container-haslabel_]:first-child {
  padding-top: 22px !important;
}

.attribute-editor-container div[class^=awsui_button-container-nolabel_]:first-child {
  padding-top: 0 !important;
}

.code-editor-container.inverse { /* the up most container of the editor */
  filter: brightness(0.85) grayscale(0.3) saturate(1.2);
}

.monaco-editor .monaco-editor-overlaymessage {
  display: none !important;
}

.monaco-editor .line-numbers {
  width: 48px !important;
}

#editorCustomErrorContent {
  font-size: 12px;
  line-height: 16px;
}

[data-classname=policyEditor] {
  padding-left: 80px !important;
  z-index: 20000 !important;
}

[data-unsaved=unsaved] {
  z-index: 1000000 !important;
}

@media (max-width: 1023px) {
  [data-classname=policyEditor] {
    padding-left: unset !important;
  }
}
.welcome-background main {
  background-image: linear-gradient(#0e0019, #261142 47%, #643dad) !important;
}

.welcome-header {
  font-size: 32px;
  color: #FFF;
  font-weight: 800;
  letter-spacing: -0.64px;
  line-height: 40px;
  text-align: left;
  font-stretch: 100%;
  margin-left: -10px;
}

.welcome-cards [data-id=buttonLinks] {
  align-items: center;
  border-radius: 80px;
  display: inline-flex;
  gap: 4px;
  padding: 8px 18px 8px 24px;
  position: relative;
  background-color: #ffffff;
  pointer-events: auto;
}

.card-item {
  pointer-events: none;
}

.welcome-cards [data-id=buttonLinks]:hover, .card-item:hover {
  transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);
  box-shadow: 0px 0px 20px #c41dff;
  border-color: #c41dff;
}

.welcome-background main div[class*=awsui_root] {
  margin-top: 0px !important;
}

.header-font {
  font-size: 32px;
  color: #FFFFFF;
}

.display-card-header {
  padding-top: 12px;
}

@media screen and (max-width: 768px) {
  .header-font {
    font-size: 30px;
  }
  .welcome-background main {
    background-image: linear-gradient(#0e0019, #261142) !important;
  }
}
.form-container {
  max-width: 1460px;
}

span[class*=awsui_toggle-control-disabled]:has(input[type=checkbox]:checked),
span[class*=awsui_toggle-control-disabled]:has(input[type=radio]:checked) {
  background: #CF4DFF !important;
  opacity: 0.5 !important;
}

.rules-details-global-services-external-icon > span {
  height: 8px !important;
  padding: 0 !important;
  margin-top: 2px !important;
}

.rules-details-global-services-external-icon > span > svg {
  height: 12px !important;
  width: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/presentation/styles/scss/link.scss","webpack://./src/presentation/styles/styles.scss","webpack://./src/presentation/styles/scss/button.scss","webpack://./src/presentation/styles/scss/_colors.scss","webpack://./src/presentation/styles/scss/icon.scss","webpack://./src/presentation/styles/scss/status-badge.scss","webpack://./src/presentation/styles/scss/layout.scss","webpack://./src/presentation/styles/scss/property-filter.scss","webpack://./src/presentation/styles/scss/onboarding.scss","webpack://./src/presentation/styles/scss/rules-library.scss","webpack://./src/presentation/styles/scss/container.scss","webpack://./src/presentation/styles/scss/select.scss","webpack://./src/presentation/styles/scss/multi-select.scss","webpack://./src/presentation/styles/scss/attribute-editor.scss","webpack://./src/presentation/styles/scss/code-editor.scss","webpack://./src/presentation/styles/scss/welcome.scss","webpack://./src/presentation/styles/scss/form.scss","webpack://./src/presentation/styles/scss/pages/rules.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;ACDF;ADEE;EACE,0BAAA;ACAJ;ADEE;EACE,mBAAA;ACAJ;;ADIA;EACE,yBAAA;EACA,2BAAA;ACDF;;ADIA;EACE,yCAAA;ACDF;;ADKA;EACE,cAAA;ACFF;;ADKA;EACE,eAAA;EACA,0BAAA;ACFF;;ADKA;EACE,aAAA;EACA,gBAAA;ACFF;;ADKA;EACE,yBAAA;ACFF;;ADKA;EACE,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,gCAAA;ACFF;;ADKA;EACE,sBAAA;ACFF;;ADKA;EACE,qCAAA;ACFF;;AC9CA;EACE,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;ADiDF;AC/CE;EACE,gDAAA;ADiDJ;AC7CE;EACE,gBAAA;AD+CJ;AC5CE;EAEE,0BAAA;EACA,8BAAA;AD6CJ;ACzCE;EACE,0BAAA;EACA,8BCzBY;AFoEhB;ACxCE;EACE,kCAAA;EACA,0BAAA;AD0CJ;ACvCE;EACE,WAAA;ADyCJ;ACtCE;EAEE,aAAA;EACA,uBAAA;EACA,kBAAA;ADuCJ;ACpCI;EACE,yBC9CY;AFoFlB;ACpCI;EACE,yBChDU;AFsFhB;ACpCI;EACE,yBCjDa;AFuFnB;ACpCI;EACE,yBAAA;ADsCN;ACpCI;EACE,yBCxDQ;AF8Fd;ACpCI;EACE,6BCxDgB;AF8FtB;ACpCI;EACE,mBAAA;EACA,yBC3DqB;AFiG3B;AClCI;EACE,aClEU;EDmEV,kBAAA;ADoCN;AChCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EAEA,cC5EU;AF6GhB;AC/BM;EACE,cClFQ;AFmHhB;AChCQ;EACE,0BAAA;EACA,8BCrFM;AFuHhB;AC9BM;EACE,gBAAA;ADgCR;AC7BM;EACE,cCtFqB;AFqH7B;AC1BI;EACE,aAAA;AD4BN;ACtBM;EACE,eAAA;EACA,iBAAA;ADwBR;ACpBI;EAQE,aAAA;ADeN;ACrBM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;ADuBR;ACfM;EACE,eAAA;EACA,iBAAA;ADiBR;ACbI;EACE,YAAA;ADeN;ACVM;EACE,eAAA;EACA,iBAAA;ADYR;ACRI;EACE,aAAA;ADUN;ACLM;EACE,eAAA;EACA,iBAAA;ADOR;;ACAA;EACE,UAAA;EACA,gBAAA;ADGF;ACDE;EACE,WAAA;ADGJ;ACAE;EACE,kCAAA;EACA,0BAAA;ADEJ;ACCE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;ADCJ;ACCI;EACE,cClLY;EDmLZ,0BAAA;ADCN;ACGI;EACE,aAAA;ADDN;ACEM;EACE,eAAA;EACA,iBAAA;ADAR;ACGI;EACE,aAAA;ADDN;ACEM;EACE,eAAA;EACA,iBAAA;ADAR;;ACMA;EACE,UAAA;EACA,eAAA;ADHF;ACKE;EACE,kCAAA;EACA,0BAAA;ADHJ;ACME;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;ADJJ;ACMI;EACE,cCvNY;EDwNZ,0BAAA;ADJN;ACQI;EACE,eAAA;ADNN;ACOM;EACE,eAAA;EACA,iBAAA;ADLR;ACQI;EACE,eAAA;ADNN;ACQM;EACE,eAAA;EACA,iBAAA;ADNR;;AGpOA;EACE,WAAA;EACA,YAAA;AHuOF;;AGpOA;EACC,6DAAA;EACA,qDAAA;AHuOD;;AGpOA;EACC,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;AHuOD;;AGpOC;EACE,iCAAA;AHuOH;;AI5PA;EACE,aAAA;EACA,mBAAA;AJ+PF;AI7PE;EACE,iBAAA;AJ+PJ;AI5PE;EACE,YAAA;AJ8PJ;;AKnQA;EAEE,aAAA;ALqQF;;AKlQA;EACE,gBAAA;EACA,yBAAA;ALqQF;;AKlQA;EACE,oCAAA;ALqQF;;AKlQA,eAAA;AACA;EACE,qBAAA;ALqQF;;AKnQA;EACE,4CAAA;ALsQF;;AK5PA;EACE,yBAAA;AL+PF;;AK5PA;EACE,wBAAA;AL+PF;;AK5PA;EACE;IACE,wBAAA;EL+PF;EK7PA;IACE,wBAAA;EL+PF;AACF;AK5PA;EACE,oBAAA;EACA,wBAAA;EACA,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;AL8PF;;AK3PA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA,EAAA,qBAAA;AL8PF;;AK3PA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AL8PF;;AK1PA;EACE,kBAAA;EACA,kBAAA;AL6PF;;AK1PA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AL6PF;;AK1PA;EACE,8BAAA;EACA,+BAAA;EAEA,wBAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,0CAAA;EACA,8BAAA;EACA,iEAAA;EACA,mCAAA;AL4PF;;AKzPA;EACE,gCAAA;EACA,4BAAA;EACA,mFAAA;EACA,kBAAA;EACA,sGAAA;EACA,+CAAA;EACA,oBAAA;EACA,0CAAA;EACA,8BAAA;EACA,iEAAA;EACA,mCAAA;AL4PF;;AK1PA;EACE,aAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;AL6PF;;AK3PA;EACE,wBAAA;AL8PF;;AK5PA;EACE,kBAAA;AL+PF;;AK7PA;EACI,yBAAA;EACA,0BAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;ALgQJ;;AK9PA;EACE,mCAAA;ALiQF;;AK/PA;EACE,kBAAA;ALkQF;;AK/PA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;ALkQF;;AKhQA;EACE,2BAAA;ALmQF;;AKjQA;EACE,2BAAA;ALoQF;;AKjQA;EACE,4BAAA;ALoQF;;AKjQA;EACE,6BAAA;ALoQF;;AKjQA;EACE;IACE,yBAAA;ELoQF;EKjQA;IACE,eAAA;ELmQF;AACF;AKhQA;EACE;IACE,iCAAA;ELkQF;EK/PA;IACE,uDAAA;ELiQF;AACF;AK9PA;EACE;IACE,0BAAA;ELgQF;EK7PA;IACE,wBAAA;EL+PF;AACF;AK7PA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AL+PF;;AK7PA;EACE,gBAAA;ALgQF;;AK9PA;EACE;IACE,eAAA;ELiQF;AACF;AMndA;EACE,aAAA;ANqdF;;AMldA;EACE,2BAAA;ANqdF;;AMldA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;ANqdF;;AOheA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;APmeF;;AOheA;EACE,YAAA;APmeF;;AOheA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;APmeF;;AOheA;EACE,UAAA;EACA,aAAA;EACA,qEAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;APmeF;;AOheA;EACE;IACE,WAAA;IACA,YAAA;EPmeF;EOjeA;IACE,eAAA;EPmeF;EOjeA;IACE,gBAAA;EPmeF;EOjeA;IACE,0BAAA;EPmeF;AACF;AOheA;EACE;IACE,eAAA;EPkeF;AACF;AO/dA;EACE;IACE,kBAAA;EPieF;EO/dA;IACE,eAAA;EPieF;AACF;AO9dA;EACE;IACE,aAAA;EPgeF;EO9dA;IACE,iBAAA;EPgeF;EO9dA;IACE,gBAAA;EPgeF;AACF;AO7dA;EACE;IACE,YAAA;EP+dF;EO7dA;IACE,aAAA;EP+dF;AACF;AO5dA;EACE;IACE,YAAA;EP8dF;EO5dA;IACE,aAAA;EP8dF;EO5dA;IACE,QAAA;IACA,SAAA;EP8dF;AACF;AQnkBA;EACE,4BAAA;EACA,4BAAA;ARqkBF;;AQlkBA;;;EAGE,oCAAA;ARqkBF;;AQlkBA;EACE;IACE,kBAAA;ERqkBF;AACF;AQlkBA;EACE,8BAAA;ARokBF;;AQjkBA;EACE,oBAAA;EACA,mBAAA;ARokBF;;AQjkBA;EACE,6BAAA;ARokBF;;AQlkBA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;ARqkBF;;AQjkBA;EACE,qBAAA;ARokBF;;AQjkBA;EACE,yBAAA;ARokBF;;AQjkBA;EACE,iBAAA;EACA,gBAAA;ARokBF;;AQlkBA;EACE,iBAAA;EACA,mBAAA;ARqkBF;;AQnkBA;EACE;IACE,aAAA;ERskBF;AACF;AQpkBA;EACE,yBAAA;EACA,WAAA;ARskBF;;AQpkBA;EACE,6BAAA;ARukBF;;AQrkBA;EACE,+BAAA;EACA,8BAAA;ARwkBF;;AQtkBA;EACE,2BAAA;ARykBF;;AQtkBA;EACE,wBAAA;ARykBF;;AQrkBA;EACE,oCAAA;EACA,yBAAA;ARwkBF;;AQrkBA;EACE,yBAAA;ARwkBF;;AQtkBA;EACE,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,0BAAA;ARykBF;;AQvkBA;EACE,sBAAA;AR0kBF;;ASxqBA;EACE,2BAAA;AT2qBF;;ASzqBA;EACE,kBAAA;AT4qBF;;ASxqBA;EACE,aAAA;AT2qBF;;ASvqBA;EACE,yCAAA;AT0qBF;;AUxrBA;EACE,4BAAA;AV2rBF;;AW5rBA;EACE,sBAAA;AX+rBF;;AW7rBA;EACE,oCAAA;EACA,oCAAA;AXgsBF;;AW9rBA;EACE,oCAAA;EACA,8BAAA;AXisBF;AWhsBE;EACE,yBAAA;AXksBJ;;AW9rBA;EACE,wBAAA;AXisBF;;AYjtBA;EACE,yBAAA;AZotBF;;AYjtBA;EACE,4BAAA;AZotBF;;AYjtBA;EACE,yBAAA;AZotBF;;Aa7tBA,iCAAA,wCAAA;EACE,qDAAA;AbguBF;;Aa7tBA;EACE,wBAAA;AbguBF;;Aa7tBA;EACE,sBAAA;AbguBF;;Aa7tBA;EACE,eAAA;EACA,iBAAA;AbguBF;;Aa7tBA;EACE,6BAAA;EACA,yBAAA;AbguBF;;Aa7tBA;EACE,2BAAA;AbguBF;;Aa7tBA;EACE;IACE,8BAAA;EbguBF;AACF;Ac7vBA;EACI,2EAAA;Ad+vBJ;;Ac7vBA;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AdgwBJ;;Ac9vBA;EACI,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AdiwBJ;;Ac/vBA;EACI,oBAAA;AdkwBJ;;AchwBA;EACI,wDAAA;EACA,gCAAA;EACA,qBAAA;AdmwBJ;;AcjwBA;EACI,0BAAA;AdowBJ;;AclwBA;EACI,eAAA;EACA,cAAA;AdqwBJ;;AcnwBA;EACI,iBAAA;AdswBJ;;AcnwBA;EACI;IACI,eAAA;EdswBN;EcpwBE;IACI,8DAAA;EdswBN;AACF;AetzBA;EACE,iBAAA;AfwzBF;;AerzBA;;EAEE,8BAAA;EACA,uBAAA;AfwzBF;;AgB/zBA;EACE,sBAAA;EACA,qBAAA;EACA,0BAAA;AhBk0BF;;AgB/zBA;EACE,uBAAA;EACA,sBAAA;AhBk0BF","sourcesContent":["@use \"colors\";\n\n.kui-link {\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n  &.disabled {\n    cursor: not-allowed;\n  }\n}\n\na[class^=\"awsui_undo-button_\"] {\n  color : #c41dff !important;\n  font-weight: 400 !important;\n}\n\na[class^=\"awsui_undo-button_\"]:hover {\n  text-decoration-color: initial !important;\n\n}\n\n.monitoringCopyLink {\n  color: #c41dff;\n}\n\n.monitoringCopyLink:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.nav-link-custom-button-class {\n  display:flex;\n  margin-top: -6px;\n}\n\n.kivera-external-link a[class^=awsui_link] {\n  color: #cf4dff !important;\n}\n\n.kivera-external-link-xs a{\n  color: #c41dff !important;\n  cursor: pointer !important;\n  font-size: 12px !important;\n  text-decoration: none !important;\n}\n\n.kivera-external-link-xs a svg{\n  width: 12px !important\n}\n\n.kivera-external-link-xs a:hover {\n  text-decoration: underline !important;\n}",".kui-link {\n  text-decoration: none;\n}\n.kui-link:hover {\n  text-decoration: underline;\n}\n.kui-link.disabled {\n  cursor: not-allowed;\n}\n\na[class^=awsui_undo-button_] {\n  color: #c41dff !important;\n  font-weight: 400 !important;\n}\n\na[class^=awsui_undo-button_]:hover {\n  text-decoration-color: initial !important;\n}\n\n.monitoringCopyLink {\n  color: #c41dff;\n}\n\n.monitoringCopyLink:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.nav-link-custom-button-class {\n  display: flex;\n  margin-top: -6px;\n}\n\n.kivera-external-link a[class^=awsui_link] {\n  color: #cf4dff !important;\n}\n\n.kivera-external-link-xs a {\n  color: #c41dff !important;\n  cursor: pointer !important;\n  font-size: 12px !important;\n  text-decoration: none !important;\n}\n\n.kivera-external-link-xs a svg {\n  width: 12px !important;\n}\n\n.kivera-external-link-xs a:hover {\n  text-decoration: underline !important;\n}\n\n.kui-button {\n  all: unset;\n  border-radius: 4px;\n  box-shadow: #A6AEAD 0 2px 4px;\n  min-width: 112px;\n}\n.kui-button:not([disabled]):focus {\n  box-shadow: #FFFFFF 0 0 0 1px, #C41DFF 0 0 0 2px;\n}\n.kui-button:focus:not(:focus-visible) {\n  box-shadow: none;\n}\n.kui-button:not([disabled]):not(.kui-button-type-ghost):hover {\n  text-decoration: underline;\n  text-decoration-color: #FFFFFF;\n}\n.kui-button-type-ghost:hover {\n  text-decoration: underline;\n  text-decoration-color: #000000;\n}\n.kui-button:active {\n  -webkit-transform: translateY(1px);\n  transform: translateY(1px);\n}\n.kui-button-fullwidth {\n  width: 100%;\n}\n.kui-button-inner {\n  display: flex;\n  justify-content: center;\n  border-radius: 4px;\n}\n.kui-button-inner-primary {\n  background-color: #C41DFF;\n}\n.kui-button-inner-secondary {\n  background-color: #000000;\n}\n.kui-button-inner-tertiary {\n  background-color: #FF8D1D;\n}\n.kui-button-inner-ghost {\n  border: 1px solid #000000;\n}\n.kui-button-inner-delete {\n  background-color: #FF471A;\n}\n.kui-button-inner-link {\n  background-color: transparent;\n}\n.kui-button-inner-disabled {\n  cursor: not-allowed;\n  background-color: #A6AEAD;\n}\n.kui-button-inner-icon {\n  fill: #FFFFFF;\n  padding-right: 8px;\n}\n.kui-button-inner-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #FFFFFF;\n}\n.kui-button-inner-text-ghost {\n  color: #000000;\n}\n.kui-button-inner-text-ghost:hover {\n  text-decoration: underline;\n  text-decoration-color: #000000;\n}\n.kui-button-inner-text:hover {\n  box-shadow: none;\n}\n.kui-button-inner-text-disabled {\n  color: #4D5453;\n}\n.kui-button-inner-large {\n  padding: 12px;\n}\n.kui-button-inner-large-text {\n  font-size: 16px;\n  line-height: 16px;\n}\n.kui-button-inner-medium {\n  padding: 12px;\n}\n.kui-button-inner-medium-icon {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.kui-button-inner-medium-text {\n  font-size: 16px;\n  line-height: 16px;\n}\n.kui-button-inner-small {\n  padding: 8px;\n}\n.kui-button-inner-small-text {\n  font-size: 12px;\n  line-height: 12px;\n}\n.kui-button-inner-extra-small {\n  padding: 12px;\n}\n.kui-button-inner-extra-small-text {\n  font-size: 10px;\n  line-height: 10px;\n}\n\n.kui-button-empty {\n  all: unset;\n  min-width: 112px;\n}\n.kui-button-empty-fullwidth {\n  width: 100%;\n}\n.kui-button-empty:active {\n  -webkit-transform: translateY(1px);\n  transform: translateY(1px);\n}\n.kui-button-empty-inner {\n  display: flex;\n  justify-content: center;\n  border-radius: 2px;\n}\n.kui-button-empty-inner-text {\n  color: #C41DFF;\n  text-decoration: underline;\n}\n.kui-button-empty-inner-large {\n  padding: 18px;\n}\n.kui-button-empty-inner-large-text {\n  font-size: 16px;\n  line-height: 16px;\n}\n.kui-button-empty-inner-medium {\n  padding: 12px;\n}\n.kui-button-empty-inner-medium-text {\n  font-size: 14px;\n  line-height: 14px;\n}\n\n.kui-button-link {\n  all: unset;\n  min-width: 30px;\n}\n.kui-button-link:active {\n  -webkit-transform: translateY(1px);\n  transform: translateY(1px);\n}\n.kui-button-link-inner {\n  display: flex;\n  justify-content: center;\n  border-radius: 2px;\n}\n.kui-button-link-inner-text {\n  color: #C41DFF;\n  text-decoration: underline;\n}\n.kui-button-link-inner-large {\n  padding: 18px 0;\n}\n.kui-button-link-inner-large-text {\n  font-size: 18px;\n  line-height: 18px;\n}\n.kui-button-link-inner-medium {\n  padding: 12px 0;\n}\n.kui-button-link-inner-medium-text {\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.kuiIcon--medium {\n  width: 16px;\n  height: 16px;\n}\n\n.kuiIcon-isLoaded {\n  -webkit-animation: kuiIconLoading 250ms ease-in 0s 1 forwards;\n  animation: kuiIconLoading 250ms ease-in 0s 1 forwards;\n}\n\n.kuiIcon {\n  -webkit-flex-shrink: 0;\n  flex-shrink: 0;\n  display: inline-block;\n  vertical-align: middle;\n  fill: currentColor;\n  -webkit-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n\n.kui-alignMiddle {\n  vertical-align: middle !important;\n}\n\n.status-badge-container {\n  display: flex;\n  align-items: center;\n}\n.status-badge-container > .text {\n  margin-right: 6px;\n}\n.status-badge-container > .icon {\n  height: 17px;\n}\n\n.sidebar-layout {\n  height: 100vh;\n}\n\n.app-layout-with-top-nav-children {\n  padding-top: 5px;\n  background-color: #efefef;\n}\n\n.metabase-background main {\n  background-color: #efefef !important;\n}\n\n/* Custom CSS */\n.hover-border-color {\n  border-color: #c41dff;\n}\n\n.hover-box-shadow {\n  box-shadow: 0 0 40px rgba(196, 29, 255, 0.5);\n}\n\n.sidebar-topnav {\n  display: block !important;\n}\n\n.sidebar-aside {\n  display: none !important;\n}\n\n@media (min-width: 1024px) and (min-height: 690px) {\n  .sidebar-topnav {\n    display: none !important;\n  }\n  .sidebar-aside {\n    display: flex !important;\n  }\n}\n:root {\n  --drop-height: 137px;\n  --bouncy-logo-size: 90px;\n  --bouncy-shadow-size: 90px;\n  --offset: -33px;\n  --shadow-height: 8px;\n  --bounce-duration: 0.9s;\n}\n\n.overlay {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100000;\n  background-color: rgba(255, 255, 255, 0.8); /*dim the background*/\n}\n\n.page-loader-container {\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n}\n\n.bouncy-component {\n  margin-left: -45px;\n  margin-top: -200px;\n}\n\n.bouncy-container {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  position: relative;\n}\n\n.bouncy-logo {\n  width: var(--bouncy-logo-size);\n  height: var(--bouncy-logo-size);\n  /* position: absolute; */\n  top: var(--offset);\n  left: calc(50% - var(--bouncy-logo-size) / 2);\n  animation-name: bounce;\n  animation-duration: var(--bounce-duration);\n  animation-direction: alternate;\n  animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);\n  animation-iteration-count: infinite;\n}\n\n.bouncy-shadow {\n  width: var(--bouncy-shadow-size);\n  height: var(--shadow-height);\n  background: radial-gradient(50% 50%, rgb(150, 150, 150), rgba(150, 150, 150, 0.05));\n  position: absolute;\n  top: calc(var(--offset) + var(--drop-height) + var(--bouncy-shadow-size) - 1.5 * var(--shadow-height));\n  left: calc(50% - var(--bouncy-shadow-size) / 2);\n  animation-name: grow;\n  animation-duration: var(--bounce-duration);\n  animation-direction: alternate;\n  animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);\n  animation-iteration-count: infinite;\n}\n\n.org-name-banner {\n  display: flex;\n  color: rgb(125, 137, 152);\n  font-weight: bold !important;\n  align-items: center;\n}\n\n.org-name-banner svg {\n  fill: rgb(125, 137, 152);\n}\n\n.org-name-icon {\n  padding-right: 7px;\n}\n\n.org-name-banner-welcome {\n  justify-content: flex-end;\n  font-size: 16px !important;\n  color: rgb(209, 213, 219) !important;\n  width: 100%;\n  padding-top: 2px;\n}\n\n.org-name-banner-welcome svg {\n  fill: rgb(209, 213, 219) !important;\n}\n\n.org-name-banner-dashboard {\n  padding: 11px 30px;\n}\n\n.org-name-banner-app {\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n  z-index: 1000000;\n}\n\n.layout-custom-class .layout-custom-header-class {\n  padding-top: 8px !important;\n}\n\n.layout-form-custom-class .layout-form-custom-header-class {\n  padding-top: 6px !important;\n}\n\ndiv[data-page=monitoring] div[class*=awsui_header-controls], div[data-page=simulator] div[class*=awsui_header-controls] {\n  padding-top: 10px !important;\n}\n\ndiv[data-page=simulator] th:first-child > div[class*=awsui_header-cell], div[data-page=simulator] td:first-child {\n  padding-left: 15px !important;\n}\n\n@media screen and (max-width: 688px) {\n  .org-name-banner {\n    padding: 10px 4px 0px 0px;\n  }\n  div[class*=awsui_breadcrumbs_]:has(div.custom-breadcrumb-class) {\n    margin-top: 0px;\n  }\n}\n@keyframes bounce {\n  from {\n    transform: translateY(0) scale(1);\n  }\n  to {\n    transform: translateY(var(--drop-height)) scale(1, 0.7);\n  }\n}\n@keyframes grow {\n  from {\n    transform: scale(0.2, 0.5);\n  }\n  to {\n    transform: scale(1, 0.8);\n  }\n}\n.customBadge {\n  background-color: #414d5c;\n  color: white;\n  border-radius: 5px;\n  padding: 0px 5px;\n}\n\n.gridFormField {\n  margin-top: 25px;\n}\n\n@media screen and (max-width: 792px) {\n  .gridFormField {\n    margin-top: 0px;\n  }\n}\n.list-property-filter {\n  display: flex;\n}\n\n.list-property-filter > div[class^=awsui_root] > div[class^=awsui_search-field] {\n  min-width: 380px !important;\n}\n\nspan[class^=awsui_filtering-match-highlight] {\n  color: #CF4DFF !important;\n  background-color: #E3E5E7 !important;\n  font-weight: normal !important;\n}\n\n.hero-gradient-wrap {\n  width: 100%;\n  height: 320px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 40px;\n  display: flex;\n  position: relative;\n}\n\n.hero-gradient-wrap.about {\n  height: auto;\n}\n\n.image-hero-wrap {\n  position: absolute;\n  top: auto;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n}\n\n.hero-gradient-rectangle {\n  width: 96%;\n  height: 100vh;\n  background-image: linear-gradient(rgba(14, 0, 25, 0.58) 43%, #643dad);\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  position: absolute;\n  top: auto;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n}\n\n@media screen and (min-width: 1440px) {\n  .image-hero {\n    width: 100%;\n    height: auto;\n  }\n  .hero-gradient-wrap {\n    margin-top: 4vw;\n  }\n  .hero-gradient-wrap.about {\n    margin-top: 40px;\n  }\n  .image-hero-wrap {\n    transform: translateY(16%);\n  }\n}\n@media screen and (min-width: 1440px) and (max-height: 960px) {\n  .image-hero-wrap {\n    transform: none;\n  }\n}\n@media screen and (min-width: 1920px) {\n  .image-hero {\n    max-height: 1000px;\n  }\n  .hero-gradient-wrap {\n    margin-top: 6vw;\n  }\n}\n@media screen and (max-width: 991px) {\n  .image-hero {\n    width: 1200px;\n  }\n  .hero-gradient-wrap {\n    margin-top: -40px;\n  }\n  .hero-gradient-wrap.about {\n    margin-top: 40px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .image-hero {\n    width: 800px;\n  }\n  .hero-gradient-wrap {\n    height: 270px;\n  }\n}\n@media screen and (max-width: 479px) {\n  .image-hero {\n    width: 630px;\n  }\n  .hero-gradient-wrap {\n    height: 220px;\n  }\n  .image-hero-wrap {\n    left: 0%;\n    right: 0%;\n  }\n}\n#rules-library-container > div > div > div > div > div[class^=awsui_header] {\n  padding-bottom: 0 !important;\n  padding-top: 17px !important;\n}\n\n#rules-library-container > div > div > div > div > div[class^=awsui_header],\n#rules-library-container > div > div > div > div > div[class^=awsui_content],\n#rules-library-container > div > div > div > div > div[class^=awsui_footer] {\n  background-color: #efefef !important;\n}\n\n@media screen and (min-width: 769px) {\n  #rules-library-container div[class^=awsui_dialog]:first-child {\n    padding-left: 75px;\n  }\n}\n#rules-library-container div[class^=awsui_header] div[class^=awsui_actions] {\n  align-items: center !important;\n}\n\n.rules-library-header div[class^=awsui_title] {\n  display: inline-flex;\n  align-items: center;\n}\n\n.rules-library-header div[class^=awsui_title] h1[class^=awsui_heading] {\n  margin-right: 16px !important;\n}\n\n.vertical-separator {\n  border-left: black;\n  height: 18px;\n  margin-top: 6px;\n  width: 6px;\n  display: block;\n}\n\n#rules-library-container > div[class^=awsui_root_] > div[class^=awsui_focus] > div[class^=awsui_dialog] > div[class^=awsui_container_] > div[class^=awsui_content_] {\n  padding: 0 !important;\n}\n\n.rules-library-provider-segment-filter div[class^=awsui_segment-part_]:not(#\\9 ) {\n  display: unset !important;\n}\n\n.imported-from-status {\n  margin-left: 10px;\n  padding-top: 2px;\n}\n\n.rules-library-header {\n  margin-left: 20px;\n  margin-bottom: -5px;\n}\n\n@media screen and (max-width: 968px) {\n  .vertical-separator {\n    display: none;\n  }\n}\n.rules-library-info-badge {\n  background-color: #FF8D1C;\n  color: #fff;\n}\n\n#rules-view-header div[class^=awsui_title] h1[class^=awsui_heading] {\n  margin-right: 16px !important;\n}\n\n#rules-view-header div[class^=awsui_title] {\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n#rules-view-header div[class^=awsui_title] span[class^=awsui_info] {\n  margin-top: -3px !important;\n}\n\n.rules-library-list-items div[class^=awsui_sticky-scrollbar] {\n  display: none !important;\n}\n\n.rules-library-provider-segment-filter button[class*=awsui_selected_] {\n  background-color: #cf4aff !important;\n  color: #FFFFFF !important;\n}\n\n.rules-library-provider-segment-filter button[class^=awsui_segment_]:hover {\n  color: #FFFFFF !important;\n}\n\n.rules-library-custom-external-link a {\n  color: #c41dff !important;\n  cursor: pointer !important;\n  text-decoration: none !important;\n  font-size: 12px !important;\n}\n\n.rules-library-custom-external-link a svg {\n  width: 12px !important;\n}\n\n.container-header-wrapper.top {\n  padding-top: 8px !important;\n}\n\n.table-header-padding {\n  padding-left: 10px;\n}\n\n[data-name=splitpanel-table] table th:nth-child(1), [data-name=splitpanel-table] table td:nth-child(1) {\n  display: none;\n}\n\n[data-name=splitpanel-table] table tr[class*=awsui_row-selected] td:nth-child(2) {\n  border-left: 2px solid #cf4dff !important;\n}\n\n.select-dropdown span[class^=awsui_placeholder_] {\n  overflow: inherit !important;\n}\n\n.multi-select-container ul li {\n  width: 100% !important;\n}\n\nul[id^=option-list] li[aria-disabled=true] {\n  background-color: #FFF7F7 !important;\n  border: 2px solid #D91515 !important;\n}\n\ndiv[class^=awsui_token_]:has(.invalid-option) {\n  border: 2px solid #D91515 !important;\n  background: #FFF7F7 !important;\n}\ndiv[class^=awsui_token_]:has(.invalid-option) span[class^=awsui_description_] {\n  color: #D91515 !important;\n}\n\nspan[class^=awsui_icon_]:has(.invalid-option) {\n  display: none !important;\n}\n\n.attribute-editor-container div[class^=awsui_controls_] {\n  padding-top: 0 !important;\n}\n\n.attribute-editor-container div[class^=awsui_button-container-haslabel_]:first-child {\n  padding-top: 22px !important;\n}\n\n.attribute-editor-container div[class^=awsui_button-container-nolabel_]:first-child {\n  padding-top: 0 !important;\n}\n\n.code-editor-container.inverse { /* the up most container of the editor */\n  filter: brightness(0.85) grayscale(0.3) saturate(1.2);\n}\n\n.monaco-editor .monaco-editor-overlaymessage {\n  display: none !important;\n}\n\n.monaco-editor .line-numbers {\n  width: 48px !important;\n}\n\n#editorCustomErrorContent {\n  font-size: 12px;\n  line-height: 16px;\n}\n\n[data-classname=policyEditor] {\n  padding-left: 80px !important;\n  z-index: 20000 !important;\n}\n\n[data-unsaved=unsaved] {\n  z-index: 1000000 !important;\n}\n\n@media (max-width: 1023px) {\n  [data-classname=policyEditor] {\n    padding-left: unset !important;\n  }\n}\n.welcome-background main {\n  background-image: linear-gradient(#0e0019, #261142 47%, #643dad) !important;\n}\n\n.welcome-header {\n  font-size: 32px;\n  color: #FFF;\n  font-weight: 800;\n  letter-spacing: -0.64px;\n  line-height: 40px;\n  text-align: left;\n  font-stretch: 100%;\n  margin-left: -10px;\n}\n\n.welcome-cards [data-id=buttonLinks] {\n  align-items: center;\n  border-radius: 80px;\n  display: inline-flex;\n  gap: 4px;\n  padding: 8px 18px 8px 24px;\n  position: relative;\n  background-color: #ffffff;\n  pointer-events: auto;\n}\n\n.card-item {\n  pointer-events: none;\n}\n\n.welcome-cards [data-id=buttonLinks]:hover, .card-item:hover {\n  transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);\n  box-shadow: 0px 0px 20px #c41dff;\n  border-color: #c41dff;\n}\n\n.welcome-background main div[class*=awsui_root] {\n  margin-top: 0px !important;\n}\n\n.header-font {\n  font-size: 32px;\n  color: #FFFFFF;\n}\n\n.display-card-header {\n  padding-top: 12px;\n}\n\n@media screen and (max-width: 768px) {\n  .header-font {\n    font-size: 30px;\n  }\n  .welcome-background main {\n    background-image: linear-gradient(#0e0019, #261142) !important;\n  }\n}\n.form-container {\n  max-width: 1460px;\n}\n\nspan[class*=awsui_toggle-control-disabled]:has(input[type=checkbox]:checked),\nspan[class*=awsui_toggle-control-disabled]:has(input[type=radio]:checked) {\n  background: #CF4DFF !important;\n  opacity: 0.5 !important;\n}\n\n.rules-details-global-services-external-icon > span {\n  height: 8px !important;\n  padding: 0 !important;\n  margin-top: 2px !important;\n}\n\n.rules-details-global-services-external-icon > span > svg {\n  height: 12px !important;\n  width: 12px !important;\n}","@use \"colors\";\n\n\n\n.kui-button {\n  all: unset;\n  border-radius: 4px;\n  box-shadow: colors.$console-box-shadow-grey 0 2px 4px;\n  min-width: 112px;\n\n  &:not([disabled]):focus {\n    box-shadow: colors.$console-white 0 0 0 1px, colors.$primary-fuschia 0 0 0 2px;\n  }\n\n  // remove the box shadow when mouse is clicked\n  &:focus:not(:focus-visible) {\n    box-shadow: none;\n  }\n\n  &:not([disabled]):not(&-type-ghost):hover {\n    //box-shadow: colors.$console-box-shadow-grey 0 4px 4px;\n    text-decoration: underline;\n    text-decoration-color: #FFFFFF;\n  }\n\n  // special case\n  &-type-ghost:hover {\n    text-decoration: underline;\n    text-decoration-color: colors.$button-secondary;\n  }\n\n  &:active {\n    -webkit-transform: translateY(1px);\n    transform: translateY(1px);\n  }\n\n  &-fullwidth {\n    width: 100%;\n  }\n\n  &-inner {\n    // buttons' properties\n    display: flex;\n    justify-content: center;\n    border-radius: 4px;\n\n    //colors\n    &-primary {\n      background-color: colors.$button-primary;\n    }\n    &-secondary {\n      background-color: colors.$button-secondary;\n    }\n    &-tertiary {\n      background-color: colors.$button-tertiary;\n    }\n    &-ghost {\n      border: 1px solid colors.$button-secondary;\n    }\n    &-delete {\n      background-color: colors.$button-delete;\n    }\n    &-link {\n      background-color: colors.$console-transparent;\n    }\n    &-disabled {\n      cursor: not-allowed;\n      background-color: colors.$button-disabled-bg;\n    }\n\n    // general icon properties\n    &-icon {\n      fill: colors.$console-white;\n      padding-right: 8px;\n    }\n\n    // general text properties\n    &-text {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      color: colors.$console-white;\n\n      &-ghost {\n        color: colors.$button-secondary;\n        &:hover {\n          text-decoration: underline;\n          text-decoration-color: colors.$button-secondary;\n        }\n      }\n\n      &:hover {\n        box-shadow: none;\n      }\n\n      &-disabled {\n        color: colors.$button-disabled-text;\n      }\n    }\n\n    //size\n    &-large {\n      padding: 12px;\n      // Safe Space\n      &-wrapper {\n        //padding: 18px;\n      }\n      // text properties\n      &-text {\n        font-size: 16px;\n        line-height: 16px;\n      }\n    }\n\n    &-medium {\n\n      &-icon {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n      }\n\n      padding: 12px;\n      // Safe Space\n      &-wrapper {\n      }\n      // text properties\n      &-text {\n        font-size: 16px;\n        line-height: 16px;\n      }\n    }\n\n    &-small {\n      padding: 8px;\n      // Safe Space\n      &-wrapper {\n      }\n      // text properties\n      &-text {\n        font-size: 12px;\n        line-height: 12px;\n      }\n    }\n\n    &-extra-small {\n      padding: 12px;\n      // Safe Space\n      &-wrapper {\n      }\n      // text properties\n      &-text {\n        font-size: 10px;\n        line-height: 10px;\n      }\n    }\n  }\n}\n\n\n.kui-button-empty {\n  all: unset;\n  min-width: 112px;\n\n  &-fullwidth {\n    width: 100%;\n  }\n\n  &:active {\n    -webkit-transform: translateY(1px);\n    transform: translateY(1px);\n  }\n\n  &-inner {\n    display: flex;\n    justify-content: center;\n    border-radius: 2px;\n\n    &-text {\n      color: colors.$primary-fuschia;\n      text-decoration: underline;\n    }\n\n    //size\n    &-large {\n      padding: 18px;\n      &-text {\n        font-size: 16px;\n        line-height: 16px;\n      }\n    }\n    &-medium {\n      padding: 12px;\n      &-text {\n        font-size: 14px;\n        line-height: 14px;\n      }\n    }\n  }\n}\n\n.kui-button-link {\n  all: unset;\n  min-width: 30px;\n\n  &:active {\n    -webkit-transform: translateY(1px);\n    transform: translateY(1px);\n  }\n\n  &-inner {\n    display: flex;\n    justify-content: center;\n    border-radius: 2px;\n\n    &-text {\n      color: colors.$primary-fuschia;\n      text-decoration: underline;\n    }\n\n    //size\n    &-large {\n      padding: 18px 0;\n      &-text {\n        font-size: 18px;\n        line-height: 18px;\n      }\n    }\n    &-medium {\n      padding: 12px 0;\n\n      &-text {\n        font-size: 16px;\n        line-height: 16px;\n      }\n    }\n  }\n}\n","$fuschia-600: #A800E4;\n\n$primary-fuschia: #C41DFF;\n$primary-black: #000000;\n$console-red: #FF471A;\n$secondary-orange: #FF8D1D;\n$console-white: #FFFFFF;\n$console-transparent: transparent;\n$console-disabled-bg-grey: #A6AEAD;\n$console-box-shadow-grey: #A6AEAD;\n$console-box-shadow-dark-grey: #828E8C;;\n$console-disabled-text-grey: #4D5453;\n\n$button-primary: $primary-fuschia;\n$button-secondary: $primary-black;\n$button-tertiary: $secondary-orange;\n$button-ghost: $console-white;\n$button-delete: $console-red;\n$button-link: $primary-fuschia;\n$button-disabled-bg: $console-disabled-bg-grey;\n$button-disabled-text: $console-disabled-text-grey;\n",".kuiIcon--medium {\n  width: 16px;\n  height: 16px;\n}\n\n.kuiIcon-isLoaded {\n -webkit-animation: kuiIconLoading 250ms ease-in 0s 1 forwards;\n animation: kuiIconLoading 250ms ease-in 0s 1 forwards;\n}\n \n.kuiIcon {\n -webkit-flex-shrink: 0;\n flex-shrink: 0;\n display: inline-block;\n vertical-align: middle;\n fill: currentColor;\n -webkit-transform: translate(0, 0);\n transform: translate(0, 0);\n}\n \n .kui-alignMiddle {\n   vertical-align: middle !important;\n }",".status-badge-container {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  & > .text {\r\n    margin-right: 6px;\r\n  }\r\n\r\n  & > .icon {\r\n    height: 17px;\r\n  }\r\n}\r\n",".default-layout {\r\n  //display: flex;\r\n}\r\n\r\n.sidebar-layout {\r\n  //position: absolute;\r\n  height: 100vh;\r\n}\r\n\r\n.app-layout-with-top-nav-children {\r\n  padding-top: 5px;\r\n  background-color: #efefef;\r\n}\r\n\r\n.metabase-background main{\r\n  background-color: #efefef !important;\r\n}\r\n\r\n/* Custom CSS */\r\n.hover-border-color {\r\n  border-color: #c41dff;\r\n}\r\n.hover-box-shadow {\r\n  box-shadow: 0 0 40px rgba(196, 29, 255, .5);\r\n}\r\n\r\n//-------------------------------------------\r\n//Required For  |   width        |   height\r\n//-------------------------------------------\r\n//TOPNAV        |   max-1023     |  max-1023\r\n//SIDENAV       |   min-1024     |  min-1024\r\n\r\n\r\n.sidebar-topnav {\r\n  display: block !important;\r\n}\r\n\r\n.sidebar-aside {\r\n  display: none !important;\r\n}\r\n\r\n@media (min-width: 1024px) and (min-height: 690px) {\r\n  .sidebar-topnav {\r\n    display: none !important;\r\n  }\r\n  .sidebar-aside {\r\n    display: flex !important;\r\n  }\r\n}\r\n\r\n:root {\r\n  --drop-height: 137px;\r\n  --bouncy-logo-size: 90px;\r\n  --bouncy-shadow-size: 90px;\r\n  --offset: -33px;\r\n  --shadow-height: 8px;\r\n  --bounce-duration: 0.9s;\r\n}\r\n\r\n.overlay {  \r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100000;\r\n  background-color: rgba(255,255,255, 0.8); /*dim the background*/\r\n}\r\n\r\n.page-loader-container {\r\n  padding: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #fff;\r\n}\r\n\r\n\r\n.bouncy-component {\r\n  margin-left: -45px;\r\n  margin-top: -200px;\r\n}\r\n\r\n.bouncy-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: transparent;\r\n  position: relative;\r\n}\r\n\r\n.bouncy-logo {\r\n  width: var(--bouncy-logo-size);\r\n  height: var(--bouncy-logo-size);\r\n\r\n  /* position: absolute; */\r\n  top: var(--offset);\r\n  left: calc(50% - var(--bouncy-logo-size)/2);\r\n  animation-name: bounce;\r\n  animation-duration: var(--bounce-duration);\r\n  animation-direction: alternate;\r\n  animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n.bouncy-shadow {\r\n  width: var(--bouncy-shadow-size);\r\n  height: var(--shadow-height);\r\n  background: radial-gradient(50% 50%, rgba(150, 150, 150, 1), rgba(150, 150, 150, 0.05));\r\n  position: absolute;\r\n  top: calc(var(--offset) + var(--drop-height) + var(--bouncy-shadow-size) - 1.5 * var(--shadow-height));\r\n  left: calc(50% - var(--bouncy-shadow-size)/2);\r\n  animation-name: grow;\r\n  animation-duration: var(--bounce-duration);\r\n  animation-direction: alternate;\r\n  animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);\r\n  animation-iteration-count: infinite;\r\n}\r\n.org-name-banner {\r\n  display: flex;\r\n  color:rgb(125, 137, 152);\r\n  font-weight: bold !important;\r\n  align-items: center;\r\n}\r\n.org-name-banner svg {\r\n  fill : rgb(125, 137, 152);\r\n}\r\n.org-name-icon {\r\n  padding-right: 7px;\r\n}\r\n.org-name-banner-welcome {   \r\n    justify-content: flex-end;\r\n    font-size: 16px !important;\r\n    color: rgb(209, 213, 219) !important;\r\n    width: 100%;\r\n    padding-top: 2px;\r\n}\r\n.org-name-banner-welcome svg {\r\n  fill : rgb(209, 213, 219) !important\r\n}\r\n.org-name-banner-dashboard {  \r\n  padding: 11px 30px;\r\n}\r\n\r\n.org-name-banner-app {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  position: relative;\r\n  z-index: 1000000;\r\n}\r\n.layout-custom-class .layout-custom-header-class{\r\n  padding-top:8px !important;\r\n}\r\n.layout-form-custom-class .layout-form-custom-header-class{\r\n  padding-top:6px !important;\r\n}\r\n\r\ndiv[data-page=\"monitoring\"] div[class*=\"awsui_header-controls\"], div[data-page=\"simulator\"] div[class*=\"awsui_header-controls\"]{  \r\n  padding-top:10px !important;\r\n}\r\n\r\ndiv[data-page=\"simulator\"] th:first-child > div[class*=\"awsui_header-cell\"], div[data-page=\"simulator\"] td:first-child  {  \r\n  padding-left: 15px !important\r\n}\r\n\r\n@media screen and (max-width: 688px) {\r\n  .org-name-banner {\r\n    padding: 10px 4px 0px 0px;\r\n  }\r\n  \r\n  div[class*=\"awsui_breadcrumbs_\"]:has(div.custom-breadcrumb-class) {\r\n    margin-top: 0px;\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  from {\r\n    transform: translateY(0) scale(1);\r\n  }\r\n\r\n  to {\r\n    transform: translateY(var(--drop-height)) scale(1, 0.7);\r\n  }\r\n}\r\n\r\n@keyframes grow {\r\n  from {\r\n    transform: scale(0.2, 0.5);\r\n  }\r\n\r\n  to {\r\n    transform: scale(1, 0.8);\r\n  }\r\n}\r\n.customBadge {  \r\n  background-color: #414d5c;\r\n  color: #ffff;\r\n  border-radius: 5px;\r\n  padding: 0px 5px;  \r\n}\r\n.gridFormField {\r\n  margin-top:25px;\r\n}\r\n@media screen and (max-width: 792px) {\r\n  .gridFormField {\r\n    margin-top:0px;\r\n  }\r\n}",".list-property-filter {\r\n  display: flex;\r\n}\r\n\r\n.list-property-filter > div[class^=\"awsui_root\"] > div[class^=\"awsui_search-field\"] {\r\n  min-width: 380px !important;\r\n}\r\n\r\nspan[class^=\"awsui_filtering-match-highlight\"] {\r\n  color : #CF4DFF !important;\r\n  background-color: #E3E5E7 !important;\r\n  font-weight: normal !important;\r\n}",".hero-gradient-wrap {\n  width: 100%;\n  height: 320px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 40px;\n  display: flex;\n  position: relative;\n}\n\n.hero-gradient-wrap.about {\n  height: auto;\n}\n\n.image-hero-wrap {\n  position: absolute;\n  top: auto;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n}\n\n.hero-gradient-rectangle {\n  width: 96%;\n  height: 100vh;\n  background-image: linear-gradient(rgba(14, 0, 25, 0.58) 43%, #643dad);\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  position: absolute;\n  top: auto;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n}\n\n@media screen and (min-width: 1440px) {\n  .image-hero {\n    width: 100%;\n    height: auto;\n  }\n  .hero-gradient-wrap {\n    margin-top: 4vw;\n  }\n  .hero-gradient-wrap.about {\n    margin-top: 40px;\n  }\n  .image-hero-wrap {\n    transform: translateY(16%);\n  }\n}\n\n@media screen and (min-width: 1440px) and (max-height: 960px) {\n  .image-hero-wrap {\n    transform: none;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .image-hero {\n    max-height: 1000px;\n  }\n  .hero-gradient-wrap {\n    margin-top: 6vw;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .image-hero {\n    width: 1200px;\n  }\n  .hero-gradient-wrap {\n    margin-top: -40px;\n  }\n  .hero-gradient-wrap.about {\n    margin-top: 40px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .image-hero {\n    width: 800px;\n  }\n  .hero-gradient-wrap {\n    height: 270px;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .image-hero {\n    width: 630px;\n  }\n  .hero-gradient-wrap {\n    height: 220px;\n  }\n  .image-hero-wrap {\n    left: 0%;\n    right: 0%;\n  }\n}","#rules-library-container > div > div > div > div > div[class^=\"awsui_header\"] {\n  padding-bottom: 0 !important;\n  padding-top: 17px !important;\n}\n\n#rules-library-container > div > div > div > div > div[class^=\"awsui_header\"],\n#rules-library-container > div > div > div > div > div[class^=\"awsui_content\"],\n#rules-library-container > div > div > div > div > div[class^=\"awsui_footer\"] {\n  background-color: #efefef !important;\n}\n\n@media screen and (min-width: 769px) {\n  #rules-library-container div[class^=\"awsui_dialog\"]:first-child {\n    padding-left: 75px;\n  }\n}\n\n#rules-library-container div[class^=\"awsui_header\"] div[class^=\"awsui_actions\"] {\n  align-items : center !important;\n}\n\n.rules-library-header div[class^=\"awsui_title\"] {\n  display: inline-flex;\n  align-items: center;\n}\n\n.rules-library-header div[class^=\"awsui_title\"] h1[class^=\"awsui_heading\"] {\n  margin-right: 16px !important;\n}\n.vertical-separator {\n  border-left: black;\n  height: 18px;\n  margin-top: 6px;\n  width: 6px;\n  display: block;\n}\n\n// specifically target only the top level element\n#rules-library-container > div[class^=\"awsui_root_\"] > div[class^=\"awsui_focus\"] > div[class^=\"awsui_dialog\"]  > div[class^=\"awsui_container_\"] > div[class^=\"awsui_content_\"] {\n  padding: 0 !important;\n}\n\n.rules-library-provider-segment-filter div[class^=\"awsui_segment-part_\"]:not(#\\9) {\n  display: unset !important;\n}\n\n.imported-from-status {\n  margin-left: 10px;\n  padding-top: 2px;\n}\n.rules-library-header {\n  margin-left:20px;\n  margin-bottom: -5px;\n}\n@media screen and (max-width: 968px) {\n  .vertical-separator {\n    display: none;\n  }\n}\n.rules-library-info-badge {  \n  background-color: #FF8D1C;\n  color: #fff;\n}\n#rules-view-header div[class^=\"awsui_title\"] h1[class^=\"awsui_heading\"] {\n  margin-right: 16px !important;\n}\n#rules-view-header div[class^=\"awsui_title\"]{\n  display: inline-flex !important;\n  align-items: center !important;\n}\n#rules-view-header div[class^=\"awsui_title\"] span[class^=\"awsui_info\"] {\n  margin-top:-3px !important;\n}\n\n.rules-library-list-items div[class^=\"awsui_sticky-scrollbar\"] {\n  display: none !important;\n}\n\n\n.rules-library-provider-segment-filter button[class*=\"awsui_selected_\"] {\n  background-color: #cf4aff !important;\n  color: #FFFFFF !important;\n}\n\n.rules-library-provider-segment-filter button[class^=\"awsui_segment_\"]:hover {\n  color: #FFFFFF !important;\n}\n.rules-library-custom-external-link a{\n  color: #c41dff !important;\n  cursor: pointer !important;\n  text-decoration: none !important;\n  font-size: 12px !important\n}\n.rules-library-custom-external-link a svg{\n  width: 12px !important\n}",".container-header-wrapper.top {\n  padding-top: 8px !important;\n}\n.table-header-padding {\n  padding-left: 10px;\n}\n// Hides the first column of the table\n// This is written to highlight the selected row without having to show the radio button column in the beginning\n[data-name=\"splitpanel-table\"] table th:nth-child(1), [data-name=\"splitpanel-table\"] table td:nth-child(1){ \n  display:none;\n}\n// Above statement ends here\n\n[data-name=\"splitpanel-table\"] table tr[class*=\"awsui_row-selected\"] td:nth-child(2){  \n  border-left: 2px solid #cf4dff !important;\n}",".select-dropdown  span[class^=\"awsui_placeholder_\"] {\n  overflow: inherit !important;\n}",".multi-select-container ul li {\n  width : 100% !important\n}\nul[id^=\"option-list\"] li[aria-disabled='true'] {\n  background-color: #FFF7F7 !important;\n  border: 2px solid #D91515 !important;\n}\ndiv[class^=\"awsui_token_\"]:has(.invalid-option) {\n  border: 2px solid #D91515 !important;\n  background:#FFF7F7 !important;\n  span[class^=\"awsui_description_\"] {    \n    color: #D91515 !important;\n  }\n}\n\nspan[class^=\"awsui_icon_\"]:has(.invalid-option) {\n  display: none  !important;\n}",".attribute-editor-container div[class^=\"awsui_controls_\"] {\n  padding-top: 0 !important;\n}\n\n.attribute-editor-container div[class^=\"awsui_button-container-haslabel_\"]:first-child {\n  padding-top: 22px !important;\n}\n\n.attribute-editor-container div[class^=\"awsui_button-container-nolabel_\"]:first-child {\n  padding-top: 0 !important;\n}",".code-editor-container.inverse { /* the up most container of the editor */\n  filter: brightness(0.85) grayscale(0.3) saturate(1.2);\n}\n\n.monaco-editor .monaco-editor-overlaymessage {\n  display: none !important;\n}\n\n.monaco-editor .line-numbers {\n  width: 48px !important;\n}\n\n#editorCustomErrorContent {\n  font-size: 12px;\n  line-height: 16px;\n}\n\n[data-classname=\"policyEditor\"] {\n  padding-left:80px !important;\n  z-index: 20000 !important;\n}\n\n[data-unsaved=\"unsaved\"] {\n  z-index: 1000000 !important\n}\n\n@media (max-width: 1023px){\n  [data-classname=\"policyEditor\"] {\n    padding-left:unset !important\n  }\n}",".welcome-background main {\n    background-image: linear-gradient(#0e0019, #261142 47%, #643dad) !important;\n}\n.welcome-header {\n    font-size: 32px;\n    color: #FFF;\n    font-weight: 800;\n    letter-spacing: -0.64px;\n    line-height: 40px;\n    text-align: left;\n    font-stretch: 100%;\n    margin-left: -10px;\n}\n.welcome-cards [data-id=\"buttonLinks\"] {\n    align-items: center;\n    border-radius: 80px;\n    display: inline-flex;\n    gap: 4px;\n    padding: 8px 18px 8px 24px;\n    position: relative;\n    background-color: #ffffff;\n    pointer-events: auto;\n}\n.card-item {    \n    pointer-events: none;\n}\n.welcome-cards [data-id=\"buttonLinks\"]:hover, .card-item:hover  {\n    transition: all .5s cubic-bezier(.215, .61, .355, 1);\n    box-shadow: 0px 0px 20px #c41dff;\n    border-color: #c41dff\n}\n.welcome-background main div[class*=\"awsui_root\"] {\n    margin-top:0px !important;\n}\n.header-font {\n    font-size: 32px;\n    color: #FFFFFF;\n}\n.display-card-header {\n    padding-top:12px\n}\n\n@media screen and (max-width: 768px) {\n    .header-font {\n        font-size: 30px;\n    }\n    .welcome-background main {\n        background-image: linear-gradient(#0e0019, #261142) !important;\n    }\n}\n",".form-container {\n  max-width: 1460px;\n}\n\nspan[class*=\"awsui_toggle-control-disabled\"]:has(input[type='checkbox']:checked), \nspan[class*=\"awsui_toggle-control-disabled\"]:has(input[type='radio']:checked)  {\n  background: #CF4DFF !important;\n  opacity: 0.5 !important;\n}",".rules-details-global-services-external-icon > span {\n  height: 8px !important;\n  padding: 0 !important;\n  margin-top: 2px !important;\n}\n\n.rules-details-global-services-external-icon > span > svg {\n  height: 12px !important;\n  width: 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
